import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import { useAlerts } from '../../alerts';
import { listEngagements } from '../../api';
import { AQUA, YELLOW, LIGHT_PURPLE } from '@wave-engagement/wave-react';
import { Check, Event, Lock, Poll, School } from '@mui/icons-material';

const Home = () => {
  const { setError, clearErrors } = useAlerts();
  const [engagements, setEngagements] = useState([]);

  useEffect(() => {
    loadEngagements();
    return () =>  clearErrors();
  }, []);

  const loadEngagements = () => {
    listEngagements().then(engagements => {
      setEngagements(engagements);
    }).catch(error => {
      setError(error ?? 'Unable to load leaderboard. Please try again.');
    });
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        {engagements.map((engagement, index) => {
          let Icon = null;
          let color = null;
          let navigateTo = null;
          switch (engagement.getType()) {
            case 'CHALLENGE':
              Icon = School;
              color = AQUA;
              navigateTo = 'challenge';
              break;
            case 'SURVEY':
              Icon = Poll;
              color = YELLOW;
              navigateTo = 'survey';
              break;
            case 'EVENT':
              Icon = Event;
              color = LIGHT_PURPLE;
              navigateTo = 'event';
              break;
            default:
              return null;
          }
          Icon = engagement.getCompleted() ? Check : (engagement.getLocked() ? Lock : Icon);
          return (
            <Button
              key={index}
              variant='contained'
              component={Link}
              to={`/${navigateTo}/${engagement.getId()}`}
              disabled={engagement.getLocked()}
              style={{ width: '100%', backgroundColor: color, marginBottom: '10px', paddingLeft: 0, paddingRight: 0 }}>
              <div style={{ width: '100%', backgroundColor: color, paddingTop: '15px', paddingBottom: '15px' }}>
                <Grid container>
                  <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Icon sx={{ color: 'slategrey', fontSize: { xs: 40, sm: 70, md: 100 } }} />
                  </Grid>
                  <Grid item xs={9} style={{ color: 'black' }}>
                    <Typography variant='h2' sx={{ fontSize: { xs: 17, sm: 24, md: 30 }, fontWeight: 'bold', marginBottom: '0.5em' }}>{engagement.getTitle() ?? 'Survey'}</Typography>
                    <Typography variant='body1' sx={{ fontSize: { xs: 15, sm: 20, md: 28 } }}>{engagement.getLocked() ? 'This lesson is locked until previous lessons are complete.' : engagement.getNotificationText()}</Typography>
                  </Grid>
                </Grid>
              </div>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
export default Home;